import { createGetPropGetter } from '@/store/utils';

export default {
  organizationFilter: createGetPropGetter('organizationFilter', []),
  dataTypeRequested: createGetPropGetter('dataTypeRequested', ''),
  domainFilter: createGetPropGetter('domainFilter', []),
  dateFilter: createGetPropGetter('dateFilter', ''),
  reportsDateFilter: createGetPropGetter('reportsDateFilter', ''),
};
